export default "__VITE_ASSET__DU__PXp3__"